import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pl-1 pr-1 mx-auto max-w-(--breakpoint-4xl)" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-2 md:gap-2" }
const _hoisted_3 = { class: "col-span-3" }
const _hoisted_4 = { class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800 mb-2" }
const _hoisted_5 = { class: "flex justify-between gap-2 mb-4" }
const _hoisted_6 = { class: "flex justify-between mb-4" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800 mb-2" }
const _hoisted_9 = { class: "flex justify-between items-center mb-4" }
const _hoisted_10 = { class: "col-span-9 space-y-2 p-4 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] scroll-container" }
const _hoisted_11 = { class: "grid grid-cols-3 gap-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")
  const _component_confirm_button = _resolveComponent("confirm_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" <Error_zone :error_zone=\"ErrorZone.application\"></Error_zone> "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_basic_button, {
              onClick: _cache[0] || (_cache[0] = $event => ($setup.router.push('/'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "fa-solid fa-home" }, null, -1 /* CACHED */),
                _createTextVNode(" Home ")
              ])),
              _: 1 /* STABLE */,
              __: [6]
            }, 8 /* PROPS */, ["size"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_basic_button, {
              onClick: _cache[1] || (_cache[1] = $event => ($setup.router.push('/reports'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "fa-regular fa-file-lines" }, null, -1 /* CACHED */),
                _createTextVNode(" Reports ")
              ])),
              _: 1 /* STABLE */,
              __: [7]
            }, 8 /* PROPS */, ["size"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_basic_button, {
              onClick: _cache[2] || (_cache[2] = $event => ($setup.router.push('/users'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "fa-solid fa-users" }, null, -1 /* CACHED */),
                _createTextVNode(" Users ")
              ])),
              _: 1 /* STABLE */,
              __: [8]
            }, 8 /* PROPS */, ["size"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_basic_button, {
              onClick: _cache[3] || (_cache[3] = $event => ($setup.new_part())),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "fa-solid fa-circle-plus" }, null, -1 /* CACHED */),
                _createTextVNode(" Add New Part ")
              ])),
              _: 1 /* STABLE */,
              __: [9]
            }, 8 /* PROPS */, ["size"])
          ]),
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Search ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.search_text) = $event)),
              placeholder: "Search...",
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.search_text]
            ])
          ])
        ]),
        _withDirectives(_createVNode($setup["EditRegisteredProduct"], {
          onSave: $setup.save_part,
          onCancel: _cache[5] || (_cache[5] = $event => ($setup.cancel_edit_part())),
          registered_product: $setup.selected_registered_product
        }, null, 8 /* PROPS */, ["registered_product"]), [
          [_vShow, $setup.opened]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[15] || (_cache[15] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Registered Product Name")
          ], -1 /* CACHED */)),
          _cache[16] || (_cache[16] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Vendor Products")
          ], -1 /* CACHED */)),
          _cache[17] || (_cache[17] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, " ")
          ], -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.registered_products, (registered_product) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (_openBlock(), _createElementBlock("div", {
                key: registered_product.id
              }, [
                _createElementVNode("strong", null, _toDisplayString(registered_product.name), 1 /* TEXT */)
              ])),
              (_openBlock(), _createElementBlock("div", {
                key: registered_product.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vendor_ids_from_registered_product(registered_product), (vendor_id) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: vendor_id,
                    class: "inline-flex mb-1 items-center gap-x-0.75 py-0.75 px-1.5 rounded-full text-xs font-medium bg-gray-300 text-foreground-inverse"
                  }, [
                    _createElementVNode("strong", null, _toDisplayString($setup.vendor_id_to_name(vendor_id)) + ": ", 1 /* TEXT */),
                    _createTextVNode(" " + _toDisplayString($setup.print_parts(registered_product, vendor_id)), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])),
              (_openBlock(), _createElementBlock("div", {
                style: {"display":"flex","align-items":"center"},
                class: "gap-2",
                key: registered_product.id
              }, [
                _createVNode(_component_basic_button, {
                  onClick: $event => ($setup.edit_part(registered_product)),
                  size: $setup.Size.small,
                  style: {"max-height":"30px"}
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "fa-solid fa-pencil" }, null, -1 /* CACHED */),
                    _createTextVNode(" Edit ")
                  ]))]),
                  _: 2 /* DYNAMIC */,
                  __: [11]
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "size"]),
                _createVNode(_component_confirm_button, {
                  onClick: $event => ($setup.delete_part(registered_product)),
                  size: $setup.Size.small,
                  style: {"max-height":"30px"},
                  class: "error"
                }, {
                  confirmation_text: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("p", null, "Are you sure you want to delete this registered product?", -1 /* CACHED */)
                  ]))]),
                  default: _withCtx(() => [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa-solid fa-circle-xmark" }, null, -1 /* CACHED */)),
                    _cache[14] || (_cache[14] = _createTextVNode(" Delete "))
                  ]),
                  _: 2 /* DYNAMIC */,
                  __: [13,14]
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "size"])
              ]))
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}